import type AuthConnector from "../data/authConnector";
import type { IPagedResults, IPagination } from "../data/types";
import Role from "entities/role";
import type EventBus from "services/eventBus";
import RepositoryBase from "./repositoryBase";
import type { IDeleteRepository, IListRepository } from "./types";

export default class RoleRepository
  extends RepositoryBase<AuthConnector>
  implements IListRepository<Role>, IDeleteRepository<Role>
{
  constructor(protected apiFactory: ReturnType<typeof AuthConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  get(id: string) {
    return this.callApi(api => api.one("roles", id).getEntity<Role>(Role));
  }

  getAll(pagination: IPagination) {
    return this.callApi(api => api.all("role_search").post<IPagedResults<Role>>(pagination));
  }

  create(entity: Role) {
    return this.callApi(api => api.all("roles").post<Role>(entity));
  }

  update(entity: Role) {
    return this.callApi(api => api.one("roles", entity.id).put<Role>(entity));
  }

  delete(entity: Role) {
    return this.callApi(api => api.one("roles", entity.id).delete(entity));
  }
}
